// extracted by mini-css-extract-plugin
export default {"footer_text":"styles_footer_text__-8Kb2","foter_links":"styles_foter_links__MAAMZ","columns":"styles_columns__W2CAK","link_list":"styles_link_list__evA4Q"};